import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'nxe-second-menu-bar',
  templateUrl: './second-menu-bar.component.html',
  styleUrls: ['./second-menu-bar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SecondMenuBarComponent {
}
